import React from "react";
import "./typing-indicator.scss";

const TypingIndicator = () => <div className="typing-indicator-ui">
      <span className="dot">.</span>
      <span className="dot">.</span>
      <span className="dot">.</span>
</div>

export default TypingIndicator;